import { render, staticRenderFns } from "./PayoutsShow.vue?vue&type=template&id=5abc6c0a&scoped=true&"
import script from "./PayoutsShow.vue?vue&type=script&lang=js&"
export * from "./PayoutsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abc6c0a",
  null
  
)

export default component.exports